import { useSearchUnloadingRawMaterialQuery } from "./unloadingApi";
import { useState } from "react";
import UnloadingModal from "./UnloadingModal";
import { useGetSummaryQuery, useGetUnloadingSummaryQuery } from "../../../app/globalApi";
import Button from "../../../components/shared/buttons/button";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Datatable from "../../../components/shared/datatable/Datatable";
import TotalCase from "../../../images/totalCase.svg";
import KgEntered from "../../../images/material_kg.svg";
import PalletizedCase from "../../../images/palletized_cases.svg";
import NotPalletizedCase from "../../../images/not_palletized_case.svg";
import DateSelector from "../../../components/shared/fields/DateSelector";
import OverviewModal from "../../../components/shared/modalContent/OverviewModal";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import { formatDateAndTimeFromUTC } from "../../../components/shared/utils";
import useTranslator from "../../../hooks/useTranslator";
import moment from "moment";
import { convertToUserTimezone, formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT, PROJECT_DATETIME_FORMAT } from "../../../helpers/constants";

const Unloading = () => {
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);

  const [showOverviewModal, setShowOverviewModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedRawMaterial, setSelectedRawMaterial] = useState(null);
  const [addRowMaterial, setAddRowMaterial] = useState(false);
  const currentDate = getCurrentDate("YYYY-MM-DD");  
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("unloading");
  const [filter, setFilter] = useState({});
  
  const [appliedFilters, setAppliedFilters] = useState({
    supplier_name: "",
    unloading_date_from: "",
    status: "",
  });

  const handleFilterApply = (newFilters) => {
    setAppliedFilters(newFilters);
    setFilter(newFilters);
  };
  
  const { _t } = useTranslator();


  const { data: rawMaterial,
          isLoading,
          isFetching : isRawMaterialFetching,
  } = useSearchUnloadingRawMaterialQuery({
            page,
            ...filter
        });
  const { data: summaryData } = useGetUnloadingSummaryQuery({ tab, date });
  const listItems = [
    {
      label: _t("total_cases", "Total Cases Entered"),
      value: summaryData?.data.total_cases_entered,
      icon: TotalCase,
    },
    {
      label: _t("material_kg", "Material Entered in KG"),
      value: summaryData?.data.material_entered_kg,
      icon: KgEntered,
    },
    {
      label: _t("palletized_cases", "Palletized Cases"),
      value: summaryData?.data.palletized_cases,
      icon: PalletizedCase,
    },
    {
      label: _t("not_palletized_cases", "Not Palletized Cases"),
      value: summaryData?.data.non_palletized_cases,
      icon: NotPalletizedCase,
    },
  ];
  const handlePageChange = (page) => {
    setPage(page);
  };
  const handleAddRawMaterial = () => {
    setAddRowMaterial(true);
    setModalMode("add");
    setSelectedRawMaterial(null);
    setShowModal(true);
  };
  const handleView = (unloading) => {
    setSelectedRawMaterial(unloading);
    setShowOverviewModal(true);
  };
  const handleEdit = (unloading) => {
    setAddRowMaterial(true);
    setModalMode("edit");
    setSelectedRawMaterial(unloading);
    setShowModal(true);
  };


  const columns = [
    { label: _t("supplier_name", "Supplier Name"), accessor: "supplier_name" },
    {
      label: _t("unloading_date", "Unloading Date"),
      accessor: "unloading_date",
      cell: ({ value }) => {
        return convertToUserTimezone(value);
      },
    },
    
    { label: _t("brix", "Brix"), accessor: "brix_level" },
    { label: _t("cases_entered", "Cases Entered"), accessor: "total_cases" },
    { label: _t("pallet_count", "Pallet Count"), accessor: "total_pallets" },
    {
      label: _t("palletized", "Palletized"),
      accessor: "palletize_cases",
    },
    {
      label: _t("unpalletized", "Unpalletized"),
      accessor: "non_palletize_cases",
    },
    { label: _t("total_kg", "Total KG"), accessor: "kg_entered" },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ value }) => (
        <span
          className={value === "counting" ? "cmn_badge inactive" : "cmn_badge"}
        >
          {value === "washing_ready"
            ? _t("Ready for Washing", "Ready for Washing")
            : value === "counting"
            ? _t("Still Counting", "Still Counting")
            : _t("Washing Done", "Washing Done")}
        </span>
      ),
    },

    {
      label: _t("overview", "Overview"),
      accessor: "status",
      cell: ({ row }) => (
        <>
          <Button
            size="small"
            label={
              row.status != "washing_done"
                ? _t("edit", "Edit")
                : _t("view", "View")
            }
            className={row.status != "washing_done" ? "" : "borderRedBtn"}
            onClick={
              row.status != "washing_done"
                ? () => handleEdit(row)
                : () => handleView(row)
            }
          />
        </>
      ),
    },
  ];
  return (
    <div>
      {addRowMaterial && (
        <UnloadingModal
          show={showModal}
          setShow={setAddRowMaterial}
          mode={modalMode}
          unloading={selectedRawMaterial}
        />
      )}
      {showOverviewModal && (
        <OverviewModal
          show={showOverviewModal}
          setShow={setShowOverviewModal}
          unloading={selectedRawMaterial}
          mode={
            selectedRawMaterial.status === "washing_ready"
              ? "unloading"
              : "washing"
          }
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("overview", "Overview")}</h6>

          <DateSelector setDate={setDate} />
        </div>
        {/* {console.log(`currentDate : ${currentDate} | | date : ${date}`)} */}
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT ) }
            />
          ))}
        </ul>
      </div>
        <Datatable
          title={_t("unloading_log", "Unloading Log")}
          columns={columns}
          tableData={rawMaterial?.data}
          buttons={[
            {
              label: _t("add_raw_material", "Add Raw Material"),
              onClick: handleAddRawMaterial,
              icon: PlusSvg,
            },
          ]}
          pagination
          page={page}
          showFilter={handleFilterApply}
          showFilterButton={true}
          onPageChange={handlePageChange}
          filterModule="unloading_filter"
          filters={appliedFilters}
          isLoading={isLoading || isRawMaterialFetching}
        />
    </div>
  );
};

export default Unloading;
